import React, { memo } from "react";
import DetalheTable from "../DetalheTable";

const Entidade = memo((props) => {
  const { segmentos, detalhe } = props;

  return <DetalheTable detalhe={detalhe} />;
});

Entidade.displayName = "Entidade";

export default Entidade;
